/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowBoldDown: {
  name: 'arrow-bold-down';
  data: string;
} = {
  name: 'arrow-bold-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22a1 1 0 0 0 .8-.4l6-8A1 1 0 0 0 18 12h-2V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v8H6a1 1 0 0 0-.8 1.6l6 8a1 1 0 0 0 .8.4Zm-4-8h1a1 1 0 0 0 1-1V4h4v9a1 1 0 0 0 1 1h1l-4 5.333L8 14Z" fill="currentColor"/></svg>`,
};
